import { render, staticRenderFns } from "./access-point-table-input.vue?vue&type=template&id=739e1f2b&scoped=true&"
import script from "./access-point-table-input.vue?vue&type=script&lang=ts&"
export * from "./access-point-table-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e1f2b",
  null
  
)

export default component.exports